"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPTIONS_PER_PAGE = void 0;
const react_1 = __importDefault(require("react"));
const styled = __importStar(require("./styled"));
const Typography_1 = require("../../../UI/Typography");
const useTranslate_1 = require("../../../../Hooks/useTranslate");
const SelectDropdown_1 = __importDefault(require("../../../UI/SelectDropdown/SelectDropdown"));
const PageSelect_1 = __importDefault(require("../../../UI/PageSelect/PageSelect"));
exports.OPTIONS_PER_PAGE = [
    { id: 0, name: '25' },
    { id: 1, name: '50' },
    { id: 2, name: '100' }
];
const PageController = ({ totalPages, itemsPerPage, setItemsPerPage, pageIndex, setPageIndex }) => {
    const { t } = (0, useTranslate_1.useTranslate)();
    return (react_1.default.createElement(styled.Container, null,
        react_1.default.createElement("div", null),
        react_1.default.createElement(PageSelect_1.default, { pageIndex: pageIndex, setPageIndex: setPageIndex, totalPages: totalPages }),
        react_1.default.createElement(styled.PerPageBlock, null,
            react_1.default.createElement(styled.Title, { type: Typography_1.Types.EYEBROW_SMALL }, t('/haldex/orders_history/items_per_page')),
            react_1.default.createElement(SelectDropdown_1.default, { options: exports.OPTIONS_PER_PAGE, value: itemsPerPage, setValue: (value) => {
                    setPageIndex(0);
                    setItemsPerPage(value);
                } }))));
};
exports.default = PageController;
